/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import { gql } from '@apollo/client';

export const GET_UPLOAD_TO_S3_URL = gql`
  query GetUploadToS3Url(
    $scope: S3FileScope!
    $scopeId: ID!
    $filename: String!
    $fields: AWSJSON
    $expiresIn: Int = 300
  ) {
    getUploadToS3Url(
      scope: $scope
      scopeId: $scopeId
      filename: $filename
      fields: $fields
      expiresIn: $expiresIn
    ) {
      url
      s3Url
      fields
    }
  }
`;
export const GET_DOWNLOAD_FROM_S3_URL = gql`
  query GetDownloadFromS3Url(
    $objectKey: String!
    $expiresIn: Int = 300
    $objectType: S3ObjectType = BRAIN_FILES
    $onlyIfExists: Boolean
  ) {
    getDownloadFromS3Url(
      objectKey: $objectKey
      expiresIn: $expiresIn
      objectType: $objectType
      onlyIfExists: $onlyIfExists
    ) {
      url
      s3Url
    }
  }
`;
